// @flow
import { useSelector } from 'react-redux';
import * as csx from 'csstips';
import classify from '@src/utils/typestyle';
import { buildQueryString } from '@src/utils/general';

import CertificateInfo from '@components/productDetail/CertificateInfo';
import BackToSearchLink from '@components/productDetail/BackToSearchLink';
import ChooseLooseDiamondButton from '@components/productDetail/ChooseLooseDiamondButton';
import LooseDiamondComboButton from '@components/productDetail/LooseDiamondComboButton';

import type { DiamondType } from '@types/diamond';

const fullWidthChooseDiamondButton = {
  ...csx.vertical,
  ...csx.start,
  '> div': {
    width: '100%'
  },
  '> div:first-child': {
    marginBottom: '20px'
  }
};

const classes = classify({
  container: {
    ...csx.horizontal,
    ...csx.betweenJustified,
    ...csx.start,
    margin: '15px 0',
    '@media (max-width: 439px)': fullWidthChooseDiamondButton,
    '@media (min-width: 680px) and (max-width: 829px)': fullWidthChooseDiamondButton
  },
  leftSection: {
    maxHeight: '88px'
  },
  rightSection: {
    flexBasis: 210,
    textAlign: 'center',

    '@media (max-width: 439px)': { flexBasis: 'auto' },
    '@media (min-width: 680px) and (max-width: 829px)': { flexBasis: 'auto' },

    $nest: {
      '& > *:nth-child(1)': {
        marginBottom: 4
      }
    }
  }
});

type PropsType = {
  diamond: DiamondType
};

export default function DiamondActions({ diamond }: PropsType) {
  const searchFilters = useSelector(state => state.diamondSearchFilters);
  const searchHref = `/loose-diamonds/search${buildQueryString(
    searchFilters,
    'diamonds'
  )}`;

  return (
    <div className={classes.container}>
      <div className={classes.leftSection}>
        <CertificateInfo url={diamond.certificate_url} />
      </div>
      <div className={classes.rightSection}>
        {diamond.has_compatible_settings ? (
          <LooseDiamondComboButton diamond={diamond} />
        ) : (
          <ChooseLooseDiamondButton diamond={diamond} />
        )}
        <BackToSearchLink url={searchHref} />
      </div>
    </div>
  );
}
